import { useState, useEffect, useRef } from 'react'
import { throttle } from 'throttle-debounce'

const useInfiniteScroll = (threshold) => {
  const [scrollRef, setScrollRef] = useState(undefined)
  const callbackRef = useRef(null)
  const [hitThreshold, setHitThreshold] = useState(false)

  const addScrollEvent = () => {
  
    const onScroll = () => {
        const scrollPositionPx = scrollRef.scrollTop - scrollRef.clientHeight
        const scrollableHeight = scrollRef.scrollHeight
        const pxToBottom = scrollableHeight + scrollPositionPx
        if (pxToBottom < threshold) {
          setHitThreshold(true)
        } else {
          setHitThreshold(false)
        }
    }
  
    scrollRef?.addEventListener("scroll", throttle(1000, onScroll));
    callbackRef.current = onScroll
  }

  useEffect(() => {
    addScrollEvent()
    return () => scrollRef?.removeEventListener("scroll", callbackRef.current);
  }, [scrollRef]);

  return {
    hitThreshold,
    setScrollRef,
    scrollRef,
  }
}

export default useInfiniteScroll
